import {Injectable} from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";
import {httpOptions} from "../../../supplier/supplier-view/supplier-view.service";

@Injectable({
  providedIn: 'root'
})
export class TaxService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  private url = 'api/tax';

  getUrl(): string {
    return this.url;
  }

//  获取模块全部数据
  getOneByCode(code): Observable<any> {
    return this.http.get(this.url+"/findOneByCode",
      {
        headers:httpOptions.headers,
        params:{code:code}
      },
    ).pipe(
      tap(() => this.log('getOneByCode')),
      catchError(this.handleError('getOneByCode')),
    );
  }

}
